import { Components, Theme } from '@mui/material';

// MUI's Alert renders its message with `theme.typography.body2`, which in this
// theme is 18px/24px — far too large for a status/error message. Align it with
// the supporting-text scale (body4: 12px mobile / 14px desktop), matching the
// `caption`-sized error styling used elsewhere in the app.
export const MuiAlert: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body4,
    }),
  },
};
